import { render } from "./ContratacaoVigenciaFinalizadaDetalheView.vue?vue&type=template&id=25237b10&scoped=true"
import script from "./ContratacaoVigenciaFinalizadaDetalheView.vue?vue&type=script&lang=js"
export * from "./ContratacaoVigenciaFinalizadaDetalheView.vue?vue&type=script&lang=js"

import "./ContratacaoVigenciaFinalizadaDetalheView.vue?vue&type=style&index=0&id=25237b10&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25237b10"]])

export default __exports__